import React, { useEffect } from 'react'
import { useSettingsHook } from '../../../../Hooks/communicators/useSettingsHook';
import { Button, Input, Switch, TextField } from '@mui/material';
import { RootState } from '../../../../Store/store';
import { useSelector } from 'react-redux';

export default function Configs() {
    const {
        setAppMaintenance,
        setFreeBlogCount,
        setFreeQnACount,
        setFreeRecipeCount,
        setVersionNumber,
        setWaterNotificationCount,
        updateData,
        configUpdateButtonLoading,
    } = useSettingsHook();
    const { configData } = useSelector((state: RootState) => state.settings.value);
    if (configData === null) {
        return <div>Loading...</div>
    };
    return (
        <div className='flex justify-start items-center flex-col w-[50rem]'>
            <p className='text-2xl font-normal mb-4'>Application Configs</p>
            <div className='flex justify-center items-center flex-col my-8 w-full'>
                <TextField
                    onChange={(e) => setVersionNumber(e.target.value)}
                    margin='normal'
                    fullWidth
                    label='Version Number'
                    value={configData.versionNumber}
                    inputMode='text'
                />
                <TextField
                    onChange={(e) => setFreeQnACount(parseInt(e.target.value))}
                    margin='normal'
                    fullWidth
                    label='Free QnA Count'
                    value={configData.freeQnACount}
                    type='number'
                />
                <TextField
                    onChange={(e) => setFreeBlogCount(parseInt(e.target.value))}
                    margin='normal'
                    fullWidth
                    label='Free Blog Count'
                    value={configData.freeBlogCount}
                    type='number'
                />
                <TextField
                    onChange={(e) => setFreeRecipeCount(parseInt(e.target.value))}
                    margin='normal'
                    fullWidth
                    label='Free Recipe Count'
                    value={configData.freeRecipeCount}
                    type='number'
                />
                <TextField
                    onChange={(e) => setWaterNotificationCount(parseInt(e.target.value))}
                    margin='normal'
                    fullWidth
                    label='Water Notification Count'
                    value={configData.waterNotificationCount}
                    type='number'
                />
                <div className='flex justify-start items-center self-start w-full'>
                    <p className='text-lg font-normal font-mono mr-4'>App Maintenance</p>
                    <Switch
                        onChange={(e) => setAppMaintenance(e.target.checked)}
                        checked={configData.appMaintenance}
                    />
                </div>
                <Button
                    disabled={configData === null || configUpdateButtonLoading}
                    onClick={updateData}
                    variant='contained'
                    color='primary'
                    sx={{ mt: 8 }}
                >
                    {
                        configUpdateButtonLoading ?
                            'Updating...' :
                            'Save Configs'
                    }
                </Button>
            </div>
        </div>
    )
}
